import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createLiveComment,
  fetchLiveComments,
} from "../redux/thunks/medicalCasesThunks";
import {
  selectLiveCommentsById,
  selectLiveCommentsError,
  selectLiveCommentsStatus,
} from "../redux/selectors/medicalCasesSelectors";

const COMMENT_POLL_INTERVAL_MS = 5000;

export function useLiveComments(liveId, enabled) {
  const dispatch = useDispatch();
  const comments = useSelector((state) =>
    selectLiveCommentsById(state, liveId)
  );
  const status = useSelector(selectLiveCommentsStatus);
  const error = useSelector(selectLiveCommentsError);

  const refresh = useCallback(() => {
    if (!liveId || !enabled) return undefined;
    return dispatch(fetchLiveComments(liveId));
  }, [dispatch, enabled, liveId]);

  useEffect(() => {
    if (!enabled) return undefined;
    refresh();
    const timer = window.setInterval(refresh, COMMENT_POLL_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, [enabled, refresh]);

  const sendComment = useCallback(
    async (content) => {
      if (!liveId || !enabled || !String(content || "").trim()) return;
      await dispatch(
        createLiveComment({ liveId, content: String(content).trim() })
      ).unwrap();
      refresh();
    },
    [dispatch, enabled, liveId, refresh]
  );

  return { comments, status, error, refresh, sendComment };
}
